import API from "../../utils/api";

export const getSalesOrderStatusApi = async (filters) => {
  const response = await API.get("order/sales-order/order-status", {
    params: filters,
  });
  return { response };
};
